import { logger } from 'shared/lib'
import { type Campaign, CampaignApi } from 'entities/Campaign'
import { CampaignEnrolmentStore } from 'pages/campaigns/ui/CampaignEnrolment'
import { openDisableCampaignModal } from './openDisableCampaignModal'

export const toggleActiveCampaign = async (campaign: Campaign): Promise<void> => {
  if (campaign.status === 'active') {
    openDisableCampaignModal(campaign.id, (data) => {
      campaign.syncOrigin(data)
    })
    return
  }

  if (campaign.status === 'disabled') {
    try {
      const { data } = await CampaignApi.patch(campaign.id, { status: 'active' })
      campaign.syncOrigin(data.data)

      const campaignEnrolmentStore = new CampaignEnrolmentStore()
      await campaignEnrolmentStore.init({
        data: {
          name: data.data.name,
          id: data.data.id,
          filters: data.data.filters,
        },
      })
    } catch (error) {
      logger.error(error)
    }
  }
}
